import {
  createBaseAsyncReducer,
  createFailAction,
  createStartAction,
  createSuccessAction,
  initialState,
  makeDataUpdaterRequireData,
} from '../redux-util/async-helpers';
import { createReducer } from '../redux-util/general-helpers';
import { removeDuplicateValues } from '../../utils/array';

export function getAsyncReducerWithModify(params) {
  return createReducer(initialState, getAsyncHandlersWithModify(params));
}

export function getAsyncHandlersWithModify({
  fetchKey,
  createKey,
  deleteKey,
  appendNode,
  itemParam,
  appendNodeCreate,
  appendOnCreate,
}) {
  const baseListReducer = createBaseAsyncReducer(fetchKey, data => {
    const result = data[appendNode]
      .filter(item => !!item[itemParam])
      .map(item => item[itemParam]);
    return {
      ...data,
      [appendNode]: result,
    };
  });

  return {
    [createSuccessAction(fetchKey).type]: (state, action) => {
      const result = baseListReducer(state, action);

      if (state.data) {
        result.data[appendNode] = removeDuplicateValues([
          ...state.data[appendNode],
          ...result.data[appendNode],
        ]);
      }
      return result;
    },
    [createFailAction(fetchKey).type]: (state, action) => {
      return baseListReducer(state, action);
    },
    [createStartAction(fetchKey).type]: (state, action) => {
      return baseListReducer(state, action);
    },
    [createSuccessAction(createKey).type]: makeDataUpdaterRequireData(
      (state, action) => {
        const newData = [...state[appendNode]];
        const newItem = action.data[appendNodeCreate][itemParam];
        if (appendOnCreate) {
          newData.push(newItem);
        } else {
          newData.unshift(newItem);
        }
        return {
          ...state,
          // don't update offset, since we don't know where in the results this item would be
          totalElements: state.totalElements + 1,
          [appendNode]: newData,
        };
      }
    ),
    [createStartAction(deleteKey).type]: makeDataUpdaterRequireData(
      (state, action) => {
        const paramStr = `${action.data[0][itemParam]}`;
        const dataStrVals = state[appendNode].map(n => `${n}`);
        const index = dataStrVals.indexOf(paramStr);
        if (index === -1) {
          return state;
        }
        const result = [...state[appendNode]];
        result.splice(index, 1);
        return {
          ...state,
          offset: state.offset - 1,
          totalElements: state.totalElements - 1,
          [appendNode]: result,
        };
      }
    ),
  };
}



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/bridge-async-modifier.js